module.exports = __webpack_public_path__ + "img/qrcode.b16aef63.png";